import React from 'react';
import classnames from 'classnames';
import SVGInline from 'react-svg-inline';

export default function ButtonGroup(props) {
  return (
    <div className="button-group">
      {props.options.map((option, index) => (
        <button
          className={classnames('button-group-button', { active: option.isActive })}
          // TODO: Fix key:
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          type="button"
          onClick={option.clickHandler}
          title={option.title}
        >
          {option.icon ? (
            <SVGInline svg={option.icon} className="button-icon" />
          ) : (
            <i className={`button-group-button-icon ${option.iconClass}`} />
          )}
        </button>
      ))}
    </div>
  );
}

ButtonGroup.propTypes = {
  options: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/properties-panel/button-group.jsx